<template>
  <div class="l-page l-page--message">

    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">配信グループの{{ messageGroupInfo.title }}</div>
        </div>
      </div>

      <!-- ユーザー情報入力エリア -->
      <form @submit.prevent>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--message-group">
            <div class="p-team-user-edit">
              <ul class="p-team-user-edit-list">
                <!-- グループ名 -->
                <li class="p-team-user-edit-list__item">
                  <div class="c-input u-w500">
                    <div class="c-input__title">グループ名</div>
                    <input
                      v-model="group_name"
                      class="c-input__item"
                      type="text"
                      name="group_name"
                      value=""
                      placeholder="グループ名を入力してください"
                    />
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </li>
                <!-- グループ名 -->
              </ul>
            </div>
          </div>
        </div>

        <div class="l-main-content">
          <!-- ボタンエリア -->
          <div class="p-team-btns" style="margin-bottom: 40px;">
            <a class="c-btn c-btn--gray u-w320" @click="onQuitClick()">
              <p class="c-btn__text">キャンセル</p>
            </a>
            <button
              class="c-btn c-btn--blue u-w320"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="add"
              value="add-user"
              @click="add()"
            >
              <p class="c-btn__text">{{ messageGroupInfo.title }}する</p>
            </button>
          </div>
          <!-- /ボタンエリア -->
        </div>
      </form>

      <div class="l-main-content">
        <div v-if="hasNotTiedMessageGroupMessages" class="p-message-result p-message-result__data" :class="{'is-loading': isLoading, 'is-loaded': isLoaded }">
          <div class="c-loader c-loader"></div>
          <div style="margin-bottom: 20px;">配信グループに紐付けられていないメッセージがあります</div>
          <table class="c-table">
            <thead>
              <tr style="white-space: nowrap;">
                <th>
                </th>
                <th class="c-table__cell--center is-sortable" style="padding: 15px !important;">
                  <span class="c-table__text">プッシュ名</span>
                  <sort-switch name="message_name" :order="sortTargets.message_name" @on-click="onClickSortButton($event)" />
                </th>
                <th class="c-table__cell--center is-sortable">
                  <span class="c-table__text">タイトル</span>
                  <sort-switch name="message_title" :order="sortTargets.message_title" @on-click="onClickSortButton($event)" />
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(messageGroup, index) in not_tied_message_group_messages" :key="index" style="white-space: nowrap;">
                <td>
                  <label class="c-checkbox__label" style="position: relative;">
                    <input
                      v-model="selectedMessage"
                      style="position: absolute; left: 0; right: 0;"
                      type="checkbox"
                      name="message_id"
                      :value="messageGroup.message_id"
                      @change="countSelectedMessage()"
                    />
                    <div class="c-checkbox__item">
                      <div class="c-checkbox__box"></div>
                    </div>
                  </label>
                </td>
                <td><p class="u-w400 u-text-ellipsis">{{ messageGroup.message_name }}</p></td>
                <td><p class="u-w400 u-text-ellipsis">{{ messageGroup.message_title }}</p></td>
                <!-- <td>{{ messageGroup.message_text }}</td> -->
              </tr>
            </tbody>

          </table>
          <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          <button
            v-show="isShowButtonMessageGroupMessage"
            class="c-btn c-btn--blue u-w320"
            style="margin-top: 30px;"
            @click="saveMessageGroupMessage()"
          >チェックしたメッセージを紐付ける</button>
        </div>
      </div>

    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

    <!-- モーダル: 配信グループ設定完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="配信グループ一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    breadcrumbData: Array,
    messageGroupInfo: Object,
  },
  data: function () {
    return {
      not_tied_message_group_messages: [],
      selectedMessage: [],
      messageIds: [],

      group_id: null,
      group_name: null,
      listUrl: null,

      errorMessage: '',
      isError: false,
      isLoadingSaveBtn: false,

      completeMessage: '',
      isCompleteMessage: false,

      isLoading: false,
      isLoaded: false,

      hasNotTiedMessageGroupMessages: false,

      isShowButtonMessageGroupMessage: false,
      isAllSelectedMessage: false,

      paginationInfo: null,
      page: 1,
      searchConditionCache: null,
      sortTargets: {
        message_name: 0,
        message_title: 0,
      },
    };
  },
  mounted: function() {
    if(this.messageGroupInfo.group_id) {
      this.group_id = this.messageGroupInfo.group_id;
    }
    if(this.messageGroupInfo.group_name) {
      this.group_name = this.messageGroupInfo.group_name;
    }
    if(this.messageGroupInfo.listUrl) {
      this.listUrl = this.messageGroupInfo.listUrl;
    }
    // 配信グループ未設定のメッセージ取得は編集時のみ
    if(this.messageGroupInfo.edit) {
      this.listNotTiedMessageGroupMessages();
    }
  },
  methods: {
    add: function () {
      // ローディング表示設定
      this.isLoadingSaveBtn = true;

      // 送信データ作成
      const data = {
        group_id: this.group_id,
        group_name: this.group_name,
      };

      // 配信グループの新規登録処理実行
      axios
        .post("/api/message-group/save", data)
        .then((res) => {
          if(res.data.result == 'NG') {
            this.isError = true;
            this.errorMessage = res.data.messages[0];
            return;
          }

          this.isCompleteMessage = true;
          this.completeMessage = '配信グループの' + this.messageGroupInfo.title + 'が完了しました。';
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = '配信グループの' + this.messageGroupInfo.title + 'に失敗しました';
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },

    // 配信グループに紐付けられていないメッセージリスト取得
    listNotTiedMessageGroupMessages(useCache) {
      useCache = useCache || false;

      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメーター作成
      let params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      }

      if (useCache) {
        // ページ情報のみ変更
        params = JSON.parse(JSON.stringify(this.searchConditionCache));
        params.params.page = this.page;
      } else {
        this.searchConditionCache = params;
      }

      this.isLoading = true;
      this.isLoaded = false;

      axios
        .get("/api/message-group/list-not-tied-message-group-messages", params)
        .then((res) => {
          if(res.data.not_tied_message_group_messages.data.length > 0) {
            this.hasNotTiedMessageGroupMessages = true;
            this.not_tied_message_group_messages = res.data.not_tied_message_group_messages.data;
            this.paginationInfo = res.data.not_tied_message_group_messages;
          } else {
            this.hasNotTiedMessageGroupMessages = false;
          }
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'データ取得に失敗しました';
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
          }, 300);
        });
    },

    // 紐付け処理実行
    saveMessageGroupMessage() {
      // 送信データ作成
      const data = {
        groupId: this.group_id,
        messageIds: this.selectedMessage,
      };

      axios
        .post('/api/message-group/save-not-tied-message-group-messages', data)
        .then(_res => {
          this.listNotTiedMessageGroupMessages();
          this.isCompleteMessage = true;
          this.completeMessage = '配信グループの紐付けが完了しました。';

          // チェックボックス・紐付け実行ボタンを初期化
          this.selectedMessage = [];
          this.isShowButtonMessageGroupMessage = false;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = '配信信グループの紐付けに失敗しました';
        });
    },

    // 紐付け実行ボタン制御
    countSelectedMessage() {
      if(this.selectedMessage.length > 0) {
        this.isShowButtonMessageGroupMessage = true;
      } else {
        this.isShowButtonMessageGroupMessage = false;
      }
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = "/coins-admin/message-group";
    },
    // クリック: 作成キャンセル
    onQuitClick: function() {
      location.href = this.listUrl;
    },

    // クリック: メッセージリストのソートボタンクリック
    onClickSortButton: function(target) {
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      // チェックボックス・紐付け実行ボタンを初期化
      this.selectedMessage = [];
      this.isShowButtonMessageGroupMessage = false;

      this.listNotTiedMessageGroupMessages();
    },

    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      // チェックボックス・紐付け実行ボタンを初期化
      this.selectedMessage = [];
      this.isShowButtonMessageGroupMessage = false;

      this.page = clickPage;
      this.listNotTiedMessageGroupMessages(true);
    },
  }
}
</script>